"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMaintenanceContext = exports.MaintenanceContext = void 0;
exports.MaintenanceContextProvider = MaintenanceContextProvider;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const UserContext_1 = require("./UserContext");
const Meta_1 = __importDefault(require("../api/Meta"));
const Authentication_1 = __importDefault(require("../shared/Authentication"));
exports.MaintenanceContext = react_1.default.createContext({
    maintenanceMode: "off",
    maintenanceCheck: false
});
function MaintenanceContextProvider(props) {
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const [maintenanceMode, setMaintenanceMode] = react_1.default.useState("off");
    const [maintenanceCheck, setMaintenanceCheck] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        if (!userContext)
            return;
        const features = userContext.client?.features;
        const timeAndAttendance = features?.find((feature) => feature.name === 'time-and-attendance');
        const notPrismTimeVendor = timeAndAttendance?.vendor?.toLowerCase() != 'prismhr';
        const timeEnabled = timeAndAttendance?.isEnabled;
        Authentication_1.default.GetToken().then((token) => Meta_1.default.isMaintenance(token).then((response) => {
            if (notPrismTimeVendor && timeEnabled)
                setMaintenanceMode(response.isMaintenance ? "prism-only" : "off");
            else
                setMaintenanceMode(response.isMaintenance ? "on" : "off");
        }).finally(() => {
            setMaintenanceCheck(true);
        })).catch(() => { });
    }, [userContext]);
    return ((0, jsx_runtime_1.jsx)(exports.MaintenanceContext.Provider, { value: {
            maintenanceMode,
            maintenanceCheck
        }, children: props.children }));
}
;
const useMaintenanceContext = () => react_1.default.useContext(exports.MaintenanceContext);
exports.useMaintenanceContext = useMaintenanceContext;
